// @flow
import ResourceDocumentProvider from "components/ResourceFill/providers/ResourceDocumentProvider";
import ResourceFormProvider from "components/ResourceFill/providers/ResourceFormProvider";
import ResourceNavigationProvider from "components/ResourceFill/providers/ResourceNavigationProvider";
import ResourceResponseProvider from "components/ResourceFill/providers/ResourceResponseProvider";
import ResourceSaveProvider from "components/ResourceFill/providers/ResourceSaveProvider";
import ResourceSessionsProvider from "components/ResourceFill/providers/ResourceSessionsProvider";
import ResourceSharedProvider from "components/ResourceFill/providers/ResourceSharedProvider";
import ResourceStripeProvider from "components/ResourceFill/providers/ResourceStripeProvider";
import ResourceSubmitProvider from "components/ResourceFill/providers/ResourceSubmitProvider";
import * as React from "react";
import type { SessionObject } from "types/session-object";
import withStripe from "utils/withStripe";

import ResourceFill from "./ResourceFill";
import type { Mode } from "./types/mode";

type Props = {
  mode: Mode,
  sessions: SessionObject,
  isTablet?: boolean,
  sessionId: string,
  setSessions: (sessions: SessionObject) => void,
  onSubmit?: () => void,
  redirectOnSubmitted?: boolean,
  isPacket?: boolean,
};

function ResourceFillWithContext({
  sessions,
  isTablet = false,
  mode,
  onSubmit,
  sessionId,
  setSessions,
  redirectOnSubmitted = false,
  isPacket = false,
}: Props): React.Node {
  return (
    <ResourceSharedProvider
      afterSubmit={onSubmit}
      isPacket={isPacket}
      isTablet={isTablet}
      mode={mode}
      redirectOnSubmitted={redirectOnSubmitted}
    >
      <ResourceSessionsProvider
        sessionId={sessionId}
        sessions={sessions}
        setSessions={setSessions}
      >
        <ResourceResponseProvider>
          <ResourceStripeProvider>
            <ResourceDocumentProvider>
              <ResourceFormProvider>
                <ResourceSaveProvider>
                  <ResourceNavigationProvider>
                    <ResourceSubmitProvider>
                      <ResourceFill />
                    </ResourceSubmitProvider>
                  </ResourceNavigationProvider>
                </ResourceSaveProvider>
              </ResourceFormProvider>
            </ResourceDocumentProvider>
          </ResourceStripeProvider>
        </ResourceResponseProvider>
      </ResourceSessionsProvider>
    </ResourceSharedProvider>
  );
}

const ResourceFillWithStripe: React.ComponentType<Props> = withStripe(
  ResourceFillWithContext,
);

export default ResourceFillWithStripe;
